<template>
  <div v-if="isInvalid" class="form-state">
    <el-empty description="La página a la que intenta ingresar no existe." />
  </div>
  <el-container v-else-if="isOk && readyToRender" class="solicitud-page">
    <el-header class="solicitud-hero">
      <div>
        <span class="solicitud-hero__badge">Solicitud digital</span>
        <h1>Formulario de solicitud de crédito</h1>
        <p>Complete la información solicitada. Los campos marcados con asterisco son obligatorios.</p>
      </div>
      <span class="solicitud-hero__role">
        {{ numberform == 1 ? "Deudor" : "Codeudor" }}
      </span>
      <template v-if="token">
        <el-col :span="24" class="solicitud-resumen">
          <p>
            <b>Deudor:</b> {{ infodeudor.deudor }}
            <br />
            <b>Fecha de solicitud:</b> {{ infodeudor.fecha_solicitud }}
            <br />
            <b>Monto solicitado:</b> {{ infodeudor.monto_solicitado }}
            <br />
            <b>Plazo solicitado:</b> {{ infodeudor.plazo_solicitado }}
          </p>
        </el-col>
      </template>
    </el-header>
    <el-main class="solicitud-main">
      <el-form v-if="!sendform" ref="formRef" class="solicitud-form" :model="formData" label-position="top" :rules="rules">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="!token">
            <el-form-item label="Asesor (Si lo tiene)">
              <el-select v-model="formData.sowe_asesor_codigo" clearable filterable>
                <el-option v-for="item in asesores" :key="item.id" :value="item.id" :label="item.descripcion" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_id_persona" prop="sowe_id_persona" label="Documento de Identidad" required
              :error="!validateDocumentoIdentidad ? 'El documento debe tener entre 6 y 10 dígitos.' : ''">
              <el-input
                v-model="formData.sowe_id_persona"
                type="number"
                @input="(val) => toUpper('sowe_id_persona', val)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_fecha_expedicion" prop="sowe_fecha_expedicion" label="Fecha expedición documento" required>
              <el-date-picker v-model="formData.sowe_fecha_expedicion" type="date" placeholder="AAAA-MM-DD"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_lugar_expedicion" prop="sowe_lugar_expedicion" label="Lugar de Expedición" required>
              <el-input v-model="formData.sowe_lugar_expedicion" type="text" @input="(val) => toUpper('sowe_lugar_expedicion', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_primer_nombre" prop="sowe_primer_nombre" label="Primer Nombre" required>
              <el-input v-model="formData.sowe_primer_nombre" type="text"  @input="(val) => toUpper('sowe_primer_nombre', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_segundo_nombre" label="Otros Nombres (Si lo tiene)">
              <el-input v-model="formData.sowe_segundo_nombre" type="text" @input="(val) => toUpper('sowe_segundo_nombre', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_primer_apellido" prop="sowe_primer_apellido" label="Primer Apellido" required>
              <el-input v-model="formData.sowe_primer_apellido" type="text" @input="(val) => toUpper('sowe_primer_apellido', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_segundo_apellido"  label="Otros Apellidos (Si lo tiene)">
              <el-input v-model="formData.sowe_segundo_apellido" type="text" @input="(val) => toUpper('sowe_segundo_apellido', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_fecha_nacimiento" prop="sowe_fecha_nacimiento" label="Fecha de Nacimiento" required>
              <el-date-picker v-model="formData.sowe_fecha_nacimiento" type="date" placeholder="AAAA-MM-DD"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_sexo" prop="sowe_sexo" label="Género" required>
              <el-select v-model="formData.sowe_sexo" filterable placeholder="Seleccionar">
                <el-option label="Masculino" value="M"></el-option>
                <el-option label="Femenino" value="F"></el-option>
                <el-option label="No Binario" value="B"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_id_estudio" prop="sowe_id_estudio" label="Título Académico" required>
              <el-select v-model="formData.sowe_id_estudio" filterable placeholder="Seleccionar"  >
                <el-option v-for="(item, i) in listTiposNivelEscolar" :key="i" :label="item.descripcion"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_telefono" prop="sowe_telefono" label="Teléfono Móvil" required>
              <el-input v-model="formData.sowe_telefono" type="tel" maxlength="10" placeholder="" @input="(val) => toUpper('sowe_telefono', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_email" prop="sowe_email" label="Dirección de Correo Electrónico" required>
              <el-input v-model="formData.sowe_email" type="email" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_dept_id" prop="sowe_dept_id" label="Departamento" required>
              <el-select v-model="formData.sowe_dept_id" filterable placeholder="Seleccionar" >
                <el-option v-for="(item, i) in listDepartamentosFiltro" :key="i" :label="item.depa_descripcion"
                  :value="item.depa_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_muni_id" prop="sowe_muni_id" label="Ciudad" required>
              <el-select v-model="formData.sowe_muni_id" filterable placeholder="Seleccionar">
                <el-option v-for="(item, i) in listMunicipios" :key="i" :label="item.nombre"
                  :value="item.cod_municipio"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_barrio" prop="sowe_barrio" label="Barrio" required>
              <el-input v-model="formData.sowe_barrio" type="text" @input="(val) => toUpper('sowe_barrio', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_direccion" prop="sowe_direccion" label="Dirección Residencia" required>
              <el-input v-model="formData.sowe_direccion" type="text" @input="(val) => toUpper('sowe_direccion', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_nacionalidad" prop="sowe_nacionalidad" label="Nacionalidad" required>
              <el-input v-model="formData.sowe_nacionalidad" type="text" @input="(val) => toUpper('sowe_nacionalidad', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_residencia_fiscal" prop="sowe_residencia_fiscal" label="Residencia Fiscal" required>
              <el-input v-model="formData.sowe_residencia_fiscal" type="text" @input="(val) => toUpper('sowe_residencia_fiscal', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_ingreso_principal" prop="sowe_ingreso_principal" label="Ingresos Mensuales" required>
              <CurrencyInput v-model="formData.sowe_ingreso_principal" :min="1" :options="currencyOptions"
                style="width: 100%; text-align: right; border: 1px solid; border-radius: 5px; border-color: #dcdfe6;"
                />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_ingreso_otro" label="Otros Ingresos" required>
              <CurrencyInput v-model="formData.sowe_ingreso_otro" :min="0" :options="currencyOptions"
                style="width: 100%; text-align: right; border: 1px solid; border-radius: 5px; border-color: #dcdfe6;"
                required   />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_egreso_principal" prop="sowe_egreso_principal" label="Gasto Mensual" required
              title="Pagos mensuales que son fijos, tales como: alimentación, arrendamientos, servicios públicos, transporte, aportes a seguridad social, entre otros.">
              <CurrencyInput v-model="formData.sowe_egreso_principal" :min="1" :options="currencyOptions"
                style="width: 100%; text-align: right; border: 1px solid; border-radius: 5px; border-color: #dcdfe6;"
                />
              <small style="display: block; margin-top: 2px; color: #606266; font-size: 12px; line-height:12px;">
                Pagos mensuales que son fijos, tales como: alimentación, arrendamientos, servicios públicos, transporte,
                aportes a seguridad social, entre otros.
              </small>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_egreso_otros" label="Egresos Mensuales" required
              title="Pagos mensuales que tienen una temporalidad establecida, tales como: cuotas de créditos, medicina prepagada, entre otros.">
              <CurrencyInput v-model="formData.sowe_egreso_otros" :min="0" :options="currencyOptions"
                style="width: 100%; text-align: right; border: 1px solid; border-radius: 5px; border-color: #dcdfe6;"
                />
              <small style="display: block; margin-top: 2px; color: #606266; font-size: 12px; line-height:12px;">
                Pagos mensuales que tienen una temporalidad establecida, tales como: cuotas de créditos, medicina
                prepagada,
                entre otros.
              </small>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_situacion_laboral" prop="sowe_situacion_laboral" label="Situación Laboral" required>
              <el-select v-model="formData.sowe_situacion_laboral" placeholder="Seleccionar" >
                <el-option value="DEPENDIENTE">Dependiente</el-option>
                <el-option value="INDEPENDIENTE">Independiente</el-option>
                <el-option value="EMPLEADO">Empleado</el-option>
                <el-option value="PENSIONADO">Pensionado</el-option>
                <el-option value="COMERCIANTE">Comerciante</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- Comerciante -->
          <template v-if="formData.sowe_situacion_laboral === 'COMERCIANTE'">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_labora" label="Nombre del Establecimiento" required>
                <el-input v-model="formData.sowe_empresa_labora" @input="(val) => toUpper('sowe_empresa_labora', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_cargo_actual" label="Descripción">
                <el-input v-model="formData.sowe_cargo_actual" required   @input="(val) => toUpper('sowe_cargo_actual', val)"></el-input>
              </el-form-item>
            </el-col>
          </template>
          <!-- Independiente -->
          <template v-if="formData.sowe_situacion_laboral === 'INDEPENDIENTE'">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_profesion" label="Profesión">
                <el-input v-model="formData.sowe_profesion" required   @input="(val) => toUpper('sowe_profesion', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item  ref="sowe_ciiu_id" label="Actividad Comercial">
                <el-select v-model="formData.sowe_ciiu_id" required   clearable filterable>
                  <el-option v-for="(item, i) in listTiposCiiu" :value="item.id" :key="i" :label="item.descripcion" />
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <!-- Dependiente Independiente-->
          <template
            v-if="formData.sowe_situacion_laboral == 'INDEPENDIENTE' || formData.sowe_situacion_laboral == 'DEPENDIENTE'">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_cargo_actual" label="Descripción">
                <el-input v-model="formData.sowe_cargo_actual" required   @input="(val) => toUpper('sowe_cargo_actual', val)"></el-input>
              </el-form-item>
            </el-col>
          </template>

          <!-- Empleado -->
          <template v-if="formData.sowe_situacion_laboral == 'EMPLEADO'">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_labora" label="Razón Social Empresa">
                <el-input v-model="formData.sowe_empresa_labora" required   @input="(val) => toUpper('sowe_empresa_labora', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item  ref="sowe_empresa_actividad" label="Actividad Comercial Empresa">
                <el-select v-model="formData.sowe_empresa_actividad" required   clearable filterable>
                  <el-option v-for="(item, i) in listTiposCiiu" :value="item.id" :key="i" :label="item.descripcion" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item  ref="sowe_empresa_depa_id" label="Departamento Dirección Empresa">
                <el-select v-model="formData.sowe_empresa_depa_id" filterable placeholder="Seleccionar" required  >
                  <el-option v-for="(item, i) in listDepartamentos" :key="i" :label="item.depa_descripcion"
                    :value="item.depa_id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_muni_id"  label="Ciudad Empresa">
                <el-select v-model="formData.sowe_empresa_muni_id" filterable placeholder="Seleccionar" required  >
                  <el-option v-for="(item, i) in listMunicipiosEmpresa" :key="i" :label="item.nombre"
                    :value="item.cod_municipio"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_barrio"  label="Barrio Empresa">
                <el-input v-model="formData.sowe_empresa_barrio" required   @input="(val) => toUpper('sowe_empresa_barrio', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_direccion" label="Dirección Empresa">
                <el-input v-model="formData.sowe_empresa_direccion" required   @input="(val) => toUpper('sowe_empresa_direccion', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="Teléfono Empresa">
                <el-input v-model="formData.sowe_empresa_telefono" required   @input="(val) => toUpper('sowe_empresa_telefono', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_cargo_actual"  label="Cargo Actual Empresa">
                <el-input v-model="formData.sowe_empresa_cargo_actual" required   @input="(val) => toUpper('sowe_empresa_cargo_actual', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_cargo_descripcion" label="Descripción del Cargo">
                <el-input v-model="formData.sowe_cargo_descripcion" type="text" maxlength="255" show-word-limit required   @input="(val) => toUpper('sowe_cargo_descripcion', val)"></el-input>
              </el-form-item>
            </el-col>
          </template>
          <!-- Fin empleado-->

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="numberform == 1">
            <el-form-item ref="sowe_linea_id" label="Línea de Crédito">
              <el-select v-model="formData.sowe_linea_id" filterable placeholder="Seleccionar" required  >
                <el-option v-for="(item, i) in listTiposLinea" :key="i" :label="item.linea_descripcion"
                  :value="item.linea_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="numberform == 1">
            <el-form-item ref="sowe_plazo_solicitado"  label="Plazo Solicitado">
              <el-select v-model="formData.sowe_plazo_solicitado" filterable placeholder="Seleccionar" required  >
                <el-option v-for="(item, i) in listPlazos" :key="i" :label="item.colipl_plazo"
                  :value="item.colipl_plazo"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="numberform == 1">
            <el-form-item ref="sowe_monto_solicitado" label="Monto Solicitado">
              <CurrencyInput v-model="formData.sowe_monto_solicitado" :min="580000" :max="29000000"
                :options="currencyOptions"
                style="width: 100%; text-align: right; border: 1px solid; border-radius: 5px; border-color: #dcdfe6;"
                required   />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="numberform == 1">
            <el-form-item ref="sowe_gara_id" label="Garantía">
              <el-select v-model="formData.sowe_gara_id" placeholder="Seleccionar" required  >
                <el-option v-for="(item, i) in listGarantiass" :key="i" :label="item.descripcion"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="numberform == 1">
            <el-form-item ref="sowe_destino_credito" label="Destino/Inversión">
              <el-input v-model="formData.sowe_destino_credito" type="text" maxlength="100" show-word-limit required   @input="(val) => toUpper('sowe_destino_credito', val)"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <!-- Sección Referencias -->
        <el-row :gutter="20">
          <template v-for="(ref, index) in formData.sowe_referencias" :key="index">
            <el-col :span="24" :style="{ 'margin-bottom': '30px', border: '1px solid #ebeef5', 'border-radius': '8px', padding: '20px' }">
              <el-divider>Referencia {{ index + 1 }}</el-divider>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Tipo de Referencia" required>
                    <el-select v-model="ref.sowe_referencia_tipo_referencia" placeholder="Seleccione tipo" style="width:100%" clearable filterable>
                      <el-option v-for="item in tiposReferencia" :key="item.id" :label="item.descripcion" :value="item.id" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Parentesco" required>
                    <el-select v-model="ref.sowe_referencia_id_parentesco" placeholder="Seleccione parentesco" style="width:100%" clearable filterable>
                      <el-option v-for="item in tiposParentesco" :key="item.id" :label="item.descripcion" :value="item.id" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Nombre(s)" required>
                    <el-input v-model="ref.sowe_referencia_nombre" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Primer Apellido" required>
                    <el-input v-model="ref.sowe_referencia_primer_apellido" required />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Segundo Apellido">
                    <el-input v-model="ref.sowe_referencia_segundo_apellido" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Dirección">
                    <el-input v-model="ref.sowe_referencia_direccion" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Teléfono" required>
                    <el-input v-model="ref.sowe_referencia_telefono" required />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </template>
        </el-row>

        <el-row :gutter="20">
          <el-col v-if="numberform == 1" @click="handleisModalOpen(1)" :span="24">
            <el-checkbox ref="sowe_aporte_donacion" v-model="formData.sowe_aporte_donacion" required  >
            </el-checkbox>
            <label  style="cursor: pointer; text-decoration: underline;">Aporte a Título de Donación
            </label>
          </el-col>
          <!-- El Aporte a Titulo de Donacion solo aplica al deudor; las Autorizaciones
               se muestran y exigen tambien al codeudor. -->
          <el-card>
            <template #header>Autorizaciones Requeridas</template>
          <el-col @click="handleisModalOpen(3)" :span="24">
            <el-checkbox ref="sowe_centrales"  v-model="formData.sowe_centrales" required  >
            </el-checkbox>
            <label style="cursor: pointer;">Autorización expresa para la consulta a
              centrales
              de información financiera
            </label>
          </el-col>
          <el-col @click="handleisModalOpen(4)" :span="24">
            <el-checkbox ref="sowe_declaracion" v-model="formData.sowe_declaracion" required  >
            </el-checkbox>
            <label  style="cursor: pointer;">Declaración origen de fondos
            </label>
          </el-col>

          <el-col @click="handleisModalOpen(2)" :span="24">
            <el-checkbox ref="sowe_autoriza_canal" v-model="formData.sowe_autoriza_canal" required  >
            </el-checkbox>
            <label  style="cursor: pointer;">Autorización expresa de los canales de
              comunicación y contacto
            </label>
          </el-col>
          <el-col @click="handleisModalOpen(5)" :span="24">
            <el-checkbox ref="sowe_tratamiento" v-model="formData.sowe_tratamiento" required  >
            </el-checkbox>
            <label  style="cursor: pointer;">Autorización expresa para el tratamiento de
              datos
              personales
            </label>
          </el-col>
        </el-card>
          <el-col :span="24" class="text-center">
            <el-popconfirm width="220" title="Seguro de enviar estos datos?" confirm-text="Si" @confirm="submitForm()">
              <template #reference>
                <el-button type="primary">Enviar formulario</el-button>
              </template>
            </el-popconfirm>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <!-- Modal usando el-dialog -->
    <el-dialog v-model="isModalOpen" width="80%" :show-close="false">
      <span>
        <aporteTitul v-if="typenum == 1" />
        <autorizacion_canales v-if="typenum == 2" />
        <consultacentral v-if="typenum == 3" />
        <declaracionorig v-if="typenum == 4" />
        <tratamientodatos v-if="typenum == 5" />
      </span>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="success" @click="dlgAccept()">Aceptar</el-button>
          <el-button type="warning" @click="dlgReject()">Rechazar</el-button>
        </div>
      </template>
    </el-dialog>
    <div class="mensaje" v-if="sendform" @click="cuenta()">
      <p>
        La solicitud de crédito ha sido radicada, la radicación no implica aceptación.
        <br />
        Por favor consulte el correo electrónico registrado ({{ formData.sowe_email }})
        y siga las instrucciones para continuar con el proceso.
      </p>
      <p>Gracias por preferirnos.</p>
      <p>Redireccionando en ({{ regresiva }})</p>
    </div>
  </el-container>
  <el-container v-else />
</template>

<style>
.form-state {
  min-height: 480px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.solicitud-page {
  width: min(1180px, calc(100% - 40px));
  margin: 36px auto 56px;
  display: block;
  overflow: visible;
}

.solicitud-hero {
  height: auto !important;
  min-height: 164px;
  padding: 30px 34px !important;
  border-radius: 22px 22px 0 0;
  color: white;
  background:
    radial-gradient(circle at 88% 25%, rgba(86, 159, 255, .38), transparent 15rem),
    linear-gradient(135deg, #092963 0%, #12458d 58%, #2473c9 100%);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  box-shadow: 0 18px 48px rgba(13, 48, 120, .18);
}

.solicitud-hero h1 {
  margin: 8px 0 6px;
  font-size: clamp(25px, 3vw, 36px);
  line-height: 1.15;
  font-weight: 750;
}

.solicitud-hero p {
  margin: 0;
  max-width: 660px;
  color: #dceaff;
}

.solicitud-hero__badge,
.solicitud-hero__role {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
}

.solicitud-hero__badge {
  color: #174981;
  background: #e9f3ff;
  padding: 6px 11px;
}

.solicitud-hero__role {
  flex: 0 0 auto;
  padding: 9px 14px;
  color: white;
  border: 1px solid rgba(255,255,255,.42);
  background: rgba(255,255,255,.12);
}

.solicitud-resumen {
  margin-top: 18px;
  padding: 14px 18px;
  border-radius: 12px;
  background: rgba(255,255,255,.12);
}

.solicitud-resumen p {
  color: white;
}

.solicitud-main {
  padding: 32px 34px 38px !important;
  border: 1px solid #dfe8f5;
  border-top: 0;
  border-radius: 0 0 22px 22px;
  background: white;
  box-shadow: 0 18px 48px rgba(13, 48, 120, .12);
}

.solicitud-form .el-form-item {
  margin-bottom: 24px;
}

.solicitud-form .el-form-item__label {
  padding-bottom: 7px;
  color: #243b5a;
  font-weight: 650;
  line-height: 1.3;
}

.solicitud-form .el-input__wrapper,
.solicitud-form .el-select__wrapper {
  min-height: 43px;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #cdd9e9 inset;
  transition: box-shadow .2s, background-color .2s;
}

.solicitud-form .el-input__wrapper:hover,
.solicitud-form .el-select__wrapper:hover {
  box-shadow: 0 0 0 1px #2473c9 inset;
}

.solicitud-form .el-input__wrapper.is-focus,
.solicitud-form .el-select__wrapper.is-focused {
  box-shadow: 0 0 0 2px rgba(36, 115, 201, .7) inset;
}

.solicitud-form .el-date-editor,
.solicitud-form .el-select {
  width: 100%;
}

.solicitud-form .el-divider {
  margin: 10px 0 26px;
}

.solicitud-form .el-divider__text {
  color: #174981;
  font-size: 16px;
  font-weight: 700;
}

.solicitud-form .el-card {
  width: 100%;
  margin: 12px 0 28px;
  border: 1px solid #dce7f5;
  border-radius: 14px;
  box-shadow: none;
}

.solicitud-form .el-card__header {
  color: #174981;
  font-weight: 700;
  background: #f4f8fd;
}

.solicitud-form .el-card__body .el-col,
.solicitud-form > .el-row:last-of-type > .el-col:first-child {
  padding: 10px 4px;
}

.solicitud-form .el-button--primary {
  min-width: 220px;
  min-height: 48px;
  margin-top: 12px;
  border: 0;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(135deg, #0d397d, #2473c9);
  box-shadow: 0 10px 24px rgba(13, 57, 125, .22);
}

.mensaje {
  max-width: 720px;
  margin: 0 auto;
  padding: 48px 28px;
  text-align: center;
  color: #183a64;
  font-size: 18px;
}

@media (max-width: 767px) {
  .solicitud-page {
    width: calc(100% - 20px);
    margin: 18px auto 32px;
  }

  .solicitud-hero {
    min-height: 0;
    padding: 24px 20px !important;
    border-radius: 16px 16px 0 0;
    flex-direction: column;
  }

  .solicitud-main {
    padding: 24px 18px 30px !important;
    border-radius: 0 0 16px 16px;
  }

  .solicitud-form .el-button--primary {
    width: 100%;
  }

  .solicitud-form .el-dialog {
    width: calc(100% - 24px) !important;
  }
}

.required::before {
  content: "*";
  color: rgba(0, 0, 0, 0);
  font-weight: bold;
}
</style>
<script>
import CurrencyInput from "./CurrencyInput";
// import axios from 'axios';
// import ModalView from "./ModalContainer";
import {
  getDepartamento,
  getDepartamentoFiltro,
  getTipoLinea,
  getTipoCiiu,
  getTipoNivelEscolar,
  getTipoGarantia,
  getSolicitudToken,
  postSolicitud,
  getMunicipio,
  getAsesores,
  getTiposReferencia,
  getTiposParentesco
} from "@/api/endpoint";
import { resolveToken } from "@/utils/tokenResolver";
import aporteTitul from '@/components/modals/aporte_titulo_donacion.vue';
import autorizacion_canales from './modals/autorizacion_canales_contacto_comunicacion.vue';
import consultacentral from './modals/consulta_centrales_información_financiera.vue';
import declaracionorig from './modals/declaracion_origen_fondos.vue';
import tratamientodatos from './modals/tratamiento_datos_personales.vue';
// const endpoint = "/";
import { ElLoading } from 'element-plus'
export default {
  props: {
    numberform: Number,
  },
  name: "FormInicialComponent",
  components: {
    CurrencyInput,
    /* ModalView */
    aporteTitul,
    autorizacion_canales,
    consultacentral,
    declaracionorig,
    tratamientodatos
  },
  data() {
    return {
      token: null,
      typenum: 1,
      isModalOpen: false,
      sendform: false,
      regresiva: 20,
      isOk: false,
      readyToRender: false,
      isInvalid: false,
      valor_minimo: 0,
      valor_maximo: 999999999,
      dataGet01: false,
      dataGet02: false,
      dataGet03: false,
      dataGet04: false,
      dataGet05: false,
      dataGet06: false,
      dataGet07: false,
      dataGet08: false,
      dataGet09: false,
      dataGet10: false,
      formData: {
        sowe_asesor_codigo: null,
        sowe_id_identificacion: 3,
        sowe_id_persona: null,
        sowe_fecha_expedicion: null,
        sowe_lugar_expedicion: null,
        sowe_primer_nombre: "",
        sowe_segundo_nombre: "",
        sowe_primer_apellido: "",
        sowe_segundo_apellido: "",
        sowe_fecha_nacimiento: null,
        sowe_nacionalidad: null,
        sowe_residencia_fiscal: null,
        sowe_sexo: "",
        sowe_id_estudio: "",
        sowe_telefono: null,
        sowe_email: null,
        sowe_dept_id: "",
        sowe_muni_id: "",
        sowe_barrio: null,
        sowe_direccion: null,
        sowe_ingreso_principal: 0,
        sowe_ingreso_otro: 0,
        sowe_egreso_principal: 0,
        sowe_egreso_otros: 0,
        sowe_situacion_laboral: "",
        sowe_cargo_actual: null,
        sowe_profesion: null,
        sowe_ciiu_id: null,
        sowe_empresa_labora: null,
        sowe_empresa_actividad: "",
        sowe_empresa_depa_id: null,
        sowe_empresa_muni_id: null,
        sowe_empresa_barrio: null,
        sowe_empresa_direccion: null,
        sowe_empresa_telefono: null,
        sowe_empresa_cargo_actual: null,
        sowe_cargo_descripcion: null,
        sowe_linea_id: 0,
        sowe_plazo_solicitado: "",
        sowe_monto_solicitado: 0,
        sowe_gara_id: null,
        sowe_destino_credito: null,
        sowe_aporte_donacion: null,
        sowe_canal_contacto: null,
        sowe_centrales: null,
        sowe_declaracion: null,
        sowe_tratamiento: null,
        sowe_autoriza_canal: null,
        sowe_padre_id: null,
        sowe_referencias: [
          {
            sowe_referencia_tipo_referencia: null,
            sowe_referencia_id_parentesco: null,
            sowe_referencia_nombre: "",
            sowe_referencia_primer_apellido: "",
            sowe_referencia_segundo_apellido: "",
            sowe_referencia_direccion: "",
            sowe_referencia_telefono: ""
          },
          {
            sowe_referencia_tipo_referencia: null,
            sowe_referencia_id_parentesco: null,
            sowe_referencia_nombre: "",
            sowe_referencia_primer_apellido: "",
            sowe_referencia_segundo_apellido: "",
            sowe_referencia_direccion: "",
            sowe_referencia_telefono: ""
          }
        ]
      },
      tiposReferencia: [{ id: 0, value: "Ninguna" }],
      tiposParentesco: [{ id: 0, value: "Ninguno" }],
      rules: {
        sowe_id_persona: [
          { required: true, message: "El documento de identidad es obligatorio", trigger: "blur" },
          { pattern: /^[0-9]{6,10}$/, message: "Debe tener entre 6 y 10 dígitos", trigger: "blur" }
        ],
        sowe_fecha_expedicion: [
          { required: true, message: "La fecha de expedición es obligatoria", trigger: "change" }
        ],
        sowe_lugar_expedicion: [
          { required: true, message: "El lugar de expedición es obligatorio", trigger: "blur" }
        ],
        sowe_primer_nombre: [
          { required: true, message: "El primer nombre es obligatorio", trigger: "blur" }
        ],
        sowe_primer_apellido: [
          { required: true, message: "El primer apellido es obligatorio", trigger: "blur" }
        ],
        sowe_fecha_nacimiento: [
          { required: true, message: "La fecha de nacimiento es obligatoria", trigger: "change" }
        ],
        sowe_nacionalidad: [
          { required: true, message: "La nacionalidad es obligatoria", trigger: "blur" }
        ],
        sowe_residencia_fiscal: [
          { required: true, message: "La residencia fiscal es obligatoria", trigger: "blur" }
        ],
        sowe_sexo: [
          { required: true, message: "El género es obligatorio", trigger: "change" }
        ],
        sowe_id_estudio: [
          { required: true, message: "El título académico es obligatorio", trigger: "change" }
        ],
        sowe_telefono: [
          { required: true, message: "El teléfono móvil es obligatorio", trigger: "blur" },
          { pattern: /^[0-9]{10}$/, message: "Debe ser un número de 10 dígitos", trigger: "blur" }
        ],
        sowe_email: [
          { required: true, message: "El correo electrónico es obligatorio", trigger: "blur" },
          { type: "email", message: "Debe ser un correo electrónico válido", trigger: "blur" }
        ],
        sowe_dept_id: [
          { required: true, message: "El departamento es obligatorio", trigger: "change" }
        ],
        sowe_muni_id: [
          { required: true, message: "La ciudad es obligatoria", trigger: "change" }
        ],
        sowe_barrio: [
          { required: true, message: "El barrio es obligatorio", trigger: "blur" }
        ],
        sowe_direccion: [
          { required: true, message: "La dirección de residencia es obligatoria", trigger: "blur" }
        ],
        sowe_ingreso_principal: [
          { required: true, message: "Los ingresos mensuales son obligatorios", trigger: "blur" },
          { type: "number", message: "Debe ser un número válido", trigger: "blur" }
        ],
        sowe_egreso_principal: [
          { required: true, message: "El gasto mensual es obligatorio", trigger: "blur" },
          { type: "number", message: "Debe ser un número válido", trigger: "blur" }
        ],
        sowe_situacion_laboral: [
          { required: true, message: "La situación laboral es obligatoria", trigger: "change" }
        ],
        sowe_centrales: [
          { required: true, message: "Debe aceptar la autorización de consulta a centrales", trigger: "change" }
        ],
        sowe_declaracion: [
          { required: true, message: "Debe aceptar la declaración de origen de fondos", trigger: "change" }
        ],
        sowe_tratamiento: [
          { required: true, message: "Debe aceptar el tratamiento de datos personales", trigger: "change" }
        ],
        sowe_autoriza_canal: [
          { required: true, message: "Debe aceptar la autorización de los canales de comunicación", trigger: "change" }
        ]
      },
      currencyOptions: {
        currency: "COP",
        currencyDisplay: "symbol",
        hideCurrencySymbolOnFocus: true,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: true,
        autoDecimalDigits: false,
        useGrouping: true,
        accountingSign: false
      },
      listDepartamentos: [],
      listDepartamentosFiltro: [],
      listMunicipios: [],
      listTiposLinea: [],
      listTiposCiiu: [],
      listTiposVivienda: [],
      listTiposNivelEscolar: [],
      listMunicipiosEmpresa: [],
      listGarantiass: [],
      asesores: [],
      listPlazos: [],
      infodeudor: {
        deudor: "",
        codeudor: "",
        email: "",
        fecha_solicitud: "",
        monto_solicitado: "",
        plazo_solicitado: 0,
      },
      loading: null
    };
  },
  watch: {
    "formData.sowe_dept_id": function () {
      this.listMunicipios = [];
      this.formData.sowe_muni_id = "";
      this.municipios();
    },
    "formData.sowe_empresa_depa_id": function () {
      this.listMunicipiosEmpresa = [];
      this.formData.sowe_empresa_muni_id = "";
      this.municipiosEmpresa();
    },
    sendform: function () {
      this.cuenta();
    },
    formData: {
      handler(newFormData) {
        // Guarda los datos en localStorage al cambiar, escopado por rol+token
        // para que un borrador de una solicitud no se filtre a otra.
        localStorage.setItem(this.storageKey(), JSON.stringify(newFormData));
      },
      deep: true,
    },
    dataGet01: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) this.isOk = true;
    },
    dataGet02: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) this.isOk = true;
    },
    dataGet03: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) this.isOk = true;
    },
    dataGet04: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) this.isOk = true;
    },
    dataGet05: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) this.isOk = true;
    },
    dataGet06: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) this.isOk = true;
    },
    dataGet07: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) this.isOk = true;
    },
    dataGet08: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) this.isOk = true;
    },
    dataGet09: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) this.isOk = true;
    },
    isOk: function (val) {
      if (val) {
        const saved = localStorage.getItem(this.storageKey());
        if (saved) {
          this.formData = JSON.parse(saved);
          if (!this.formData.sowe_referencias || this.formData.sowe_referencias.length === 0) {
            this.formData.sowe_referencias = [
              { sowe_referencia_tipo_referencia: null, sowe_referencia_id_parentesco: null, sowe_referencia_nombre: "", sowe_referencia_primer_apellido: "", sowe_referencia_segundo_apellido: "", sowe_referencia_direccion: "", sowe_referencia_telefono: "" },
              { sowe_referencia_tipo_referencia: null, sowe_referencia_id_parentesco: null, sowe_referencia_nombre: "", sowe_referencia_primer_apellido: "", sowe_referencia_segundo_apellido: "", sowe_referencia_direccion: "", sowe_referencia_telefono: "" }
            ];
          }
        }
      }
    },
  },
  computed: {
    validateDocumentoIdentidad() {
      const length = String(this.formData.sowe_id_persona).length;
      return length >= 6 && length <= 10;
    },
    validateEmail() {
      const email = String(this.formData.sowe_email);
      const regex = /\S+@\S+\.\S+/;
      return regex.test(email);
    },
  },
  beforeMount() {
    this.token = resolveToken(this.$route);
    const startYear = 0;
    this.listPlazos = Array.from({ length: 36 }, (_, i) => ({ linea_id: startYear, colipl_plazo: i + 1 }));
    if (this.token) {
      console.log("Validando Token:", this.token);
      getSolicitudToken(this.token)
        .then((response) => {
          if (response.status === 200) {
            this.infodeudor = response.data;
            if (this.infodeudor && this.infodeudor.monto_solicitado && this.infodeudor.monto_solicitado > 0) {
              this.infodeudor.monto_solicitado = new Intl.NumberFormat(
                "es-CO",
                { style: "currency", currency: "COP" }
              ).format(this.infodeudor.monto_solicitado);
              this.formData.sowe_email = this.infodeudor.email;
              this.formData.sowe_primer_nombre = this.infodeudor.codeudor;
              this.readyToRender = true;
              this.isOk = true;
              this.isInvalid = false;
              this.$forceUpdate();
            } else {
              this.isInvalid = true;
            }
          } else {
            this.isInvalid = true;
          }
        })
        .catch(() => {
          this.isInvalid = true;
        });
      this.getSelectorData();
    } else {
      this.getSelectorData();
      this.readyToRender = true;
    }
  },
  methods: {
    // Clave de borrador por rol+token: evita que datos de una solicitud (p. ej.
    // Otros Nombres o Autorizaciones ya aceptadas) reaparezcan en otra distinta.
    storageKey() {
      return `formDataSolFap-${this.numberform}-${this.token || "sinToken"}`;
    },
    getSelectorData() {
      getAsesores().then((response) => { this.asesores = response.data; this.dataGet01 = true; });
      getDepartamento().then((response) => { this.listDepartamentos = response.data; this.dataGet02 = true; }).catch((e) => { console.log(e); });
      getDepartamentoFiltro().then((response) => { this.listDepartamentosFiltro = response.data; this.dataGet03 = true; }).catch((e) => { console.log(e); });
      getTipoLinea().then((response) => { this.listTiposLinea = response.data; this.dataGet04 = true; }).catch((e) => { console.log(e); });
      getTipoCiiu().then((response) => { this.listTiposCiiu = response.data; this.dataGet05 = true; }).catch((e) => { console.log(e); });
      getTipoNivelEscolar().then((response) => { this.listTiposNivelEscolar = response.data; this.dataGet06 = true; }).catch((e) => { console.log(e); });
      getTipoGarantia().then((response) => { this.listGarantiass = response.data; this.dataGet07 = true; }).catch((e) => { console.log(e); });
      getTiposReferencia().then((response) => { this.tiposReferencia = response.data.filter((e) => e.id === 1 || e.id === 2); this.dataGet08 = true; }).catch((e) => { console.log(e); });
      getTiposParentesco().then((response) => { this.tiposParentesco = response.data; this.dataGet09 = true; }).catch((e) => { console.log(e); });
    },
    showLoading() {
      this.loading = ElLoading.service({
        lock: true,
        text: 'Enviando Datos...',
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
    closeLoading() {
      this.loading.close()
    },
    handleisModalOpen(type) {
      console.log('Cambiando a Dialogo: ', type)
      this.typenum = type
      this.isModalOpen = true
    },
    titleLineaCredito() {
      return 'CrediApoyo -> Credito de Consumo'
    },
    cuenta() {
      this.regresiva = this.regresiva - 1;
      console.log(this.regresiva);
      if (this.regresiva == 0) {
        location.href = "https://fundacionapoyo.com/";
        return;
      }
      setTimeout(() => {
        this.cuenta();
      }, 1000);
    },
    submitForm() {
      console.log("Enviando Formulario")
      if (this.numberform == 2) {
        this.formData.sowe_padre_id = this.token;
      }
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.formData.sowe_fecha_expedicion = new Date(
            this.formData.sowe_fecha_expedicion
          ).getTime();
          this.formData.sowe_fecha_nacimiento = new Date(
            this.formData.sowe_fecha_nacimiento
          ).getTime();
          this.formData.sowe_aporte_donacion = this.formData.sowe_aporte_donacion ? 1 : 0;
          this.formData.sowe_centrales = this.formData.sowe_centrales ? 1 : 0;
          this.formData.sowe_declaracion = this.formData.sowe_declaracion ? 1 : 0;
          this.formData.sowe_tratamiento = this.formData.sowe_tratamiento ? 1 : 0;
          this.formData.sowe_autoriza_canal = this.formData.sowe_autoriza_canal ? 1 : 0;
          this.formData.sowe_plazo_solicitado = parseInt(this.formData.sowe_plazo_solicitado);
          this.formData.sowe_ciiu_id = parseInt(this.formData.sowe_ciiu_id);
          this.formData.sowe_empresa_actividad = parseInt(this.formData.sowe_empresa_actividad);
          console.log(this.formData);
          if (
            this.formData.sowe_centrales == 1 &&
            this.formData.sowe_declaracion == 1 &&
            this.formData.sowe_tratamiento == 1 &&
            this.formData.sowe_autoriza_canal == 1) {
            this.showLoading();
            console.log("Enviando formulario:", this.formData);
            postSolicitud(this.formData)
              .then(() => {
                this.sendform = true;
                localStorage.removeItem(this.storageKey());
                this.closeLoading();
              })
              .catch((error) => {
                this.closeLoading();
                alert('Error al enviar el formulario, por favor intente nuevamente')
                console.log(error);
              });
          } else {
            alert('Por favor revise que todos los campos requeridos esten diligenciados y acepte los términos y condiciones')
          }
        } else {
          alert('Por favor complete todos los campos requeridos correctamente.');
        }
      });
    },
    municipios() {
      // axios.get(`${endpoint}/api/web/tmun01/${this.formData.sowe_dept_id}/39913492-498b-44ea-831c-28ba909f5fa4`)
      getMunicipio(this.formData.sowe_dept_id)
        .then((response) => {
          this.listMunicipios = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    municipiosEmpresa() {
      // axios.get(`${endpoint}/api/web/tmun01/${this.formData.sowe_empresa_depa_id}/39913492-498b-44ea-831c-28ba909f5fa4`)
      getMunicipio(this.formData.sowe_empresa_depa_id)
        .then((response) => {
          this.listMunicipiosEmpresa = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    dlgAccept() {
      this.isModalOpen = false
      switch (this.typenum) {
        case 1:
          this.formData.sowe_aporte_donacion = true
          break;
        case 2:
          this.formData.sowe_autoriza_canal = true
          break;
        case 3:
          this.formData.sowe_centrales = true
          break;
        case 4:
          this.formData.sowe_declaracion = true
          break;
        case 5:
          this.formData.sowe_tratamiento = true
          break;
      }
    },
    dlgReject() {
      this.isModalOpen = false
      switch (this.typenum) {
        case 1:
          this.formData.sowe_aporte_donacion = false
          break;
        case 2:
          this.formData.sowe_autoriza_canal = false
          break;
        case 3:
          this.formData.sowe_centrales = false
          break;
        case 4:
          this.formData.sowe_declaracion = false
          break;
        case 5:
          this.formData.sowe_tratamiento = false
          break;
      }
    },
    toUpper(campo, valor) {
      // Conviertes el valor a mayúsculas y reasignas a tu variable
      this.formData[campo] = valor.toUpperCase();
    }
  },
};
</script>
